import {BasicCriteria} from '../../framework/parameters/BasicCriteria';

export class ProfileCriteria extends BasicCriteria {
visionCode: string;
visionCodeList: string[];
withoutWildcard: boolean | null;
}

